import en from "lang/en.json";
import es from "lang/es.json";
import React from "react";
import AlliancesSection from "@components-pages/prestamos-hipotecarios/alliances-section";
import CoverSection from "@components-pages/prestamos-hipotecarios/cover-section";
import HeadMeta, { IHeadMetaComponent } from "@components/head-meta";
import { useRouter } from "next/router";
import { CKeyWordsPages } from "shared/models/const/keywords.const";

import type { GetStaticPropsContext, NextPage } from "next";
import WsPhantomNav from "@components/a1-refactor/typography/WsPhantomNav";
import { Box, styled } from "@mui/material";
export async function getStaticProps({ locale }: GetStaticPropsContext) {
  return {
    props: {
      messages: locale === "es" ? es : en,
    },
  };
}

const PrestamosHipotecarios: NextPage = () => {
  const router = useRouter();

  const metaData: IHeadMetaComponent = {
    title: "mortgageLoans",
    description: "mortgage-load",
    keyWords: CKeyWordsPages.mortgageLoad,
    url: router.asPath,
    picture: "/images/image-optimize/bussiness-people.webp",
  };

  return (
    <>
      <HeadMeta {...metaData} />
      <WsPhantomNav />

      <CoverSection></CoverSection>

      <MainContainer>
        <ElementForm />
        <Content>
          <AlliancesSection></AlliancesSection>
        </Content>
      </MainContainer>
    </>
  );
};

export default PrestamosHipotecarios;

const MainContainer = styled(Box)`
  width: 100%;
  height: 100%;
  background-color: var(--color-brand-cream-primary);
  position: relative;
  z-index: 9;
`;

const Content = styled(Box)`
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 11;
  @media (max-width: 900px) {
    padding-top: 50px;
  }
`;

const ElementForm = styled(Box)`
  border-radius: 200px 0px 0px 0px;
  position: absolute;
  z-index: 10;
  top: -100px;
  width: 100%;
  min-height: 100px;
  background-color: var(--color-brand-cream-primary);
  @media (max-width: 1200px) {
  }
  @media (max-width: 900px) {
    border-radius: 0px;
    display: none;
  }
  @media (max-width: 600px) {
  }
`;
